import {CanDeactivate} from '@angular/router';
import {Injectable} from '@angular/core';
import {TranslationsListComponent} from '../pages/translate/translations-list/translations-list.component';

@Injectable()
export class TranslationsFormSaved implements CanDeactivate<TranslationsListComponent> {

  /**
   * Prevent leaving the translation page without saving penging modifications
   * @param {TranslationsListComponent} component
   * @returns {any}
   */
  canDeactivate(component: TranslationsListComponent) {
    if (component.getNumberOfTranslationModified() === 0) {
      return true;
    } else {
      return component.formSavedCheck();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/routing/translations-form-saved.ts